module.exports = __webpack_public_path__ + "static/img/missedPenalty.b8249b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/missedPenalty.png
// module id = 3ym1
// module chunks = 94